import { TableRow as MuiTableRow } from '@mui/material';
import { styled } from '@mui/material/styles';
import { excludeProps } from '@shared/theme/util';

interface TableBodyRowProps {
  isClickable?: boolean;
  isHighlight?: boolean;
}

export const TableRow = styled(MuiTableRow, {
  name: 'Table',
  slot: 'TableRow',
  shouldForwardProp: (propName) =>
    excludeProps(propName, ['isClickable', 'isHighlight']),
})<TableBodyRowProps>(({ theme, isClickable, isHighlight }) => ({
  ...(isHighlight === true && {
    background: theme.palette.getGrey(20),
  }),
  ...(isClickable === true && {
    '&:hover': {
      cursor: 'pointer',
      background: theme.palette.getGrey(20),
      transition: '100ms',
    },
  }),
}));
